export default {
  model: [
    {
      label: 'Nome',
      field: 'name',
      type: 'text'
    },
    {
      label: 'Situação do cliente',
      field: 'status',
      type: 'text'
    },
  ]
}
